export const getNewPagePlacement = (
  currentlyDisplayedPageIndex: number,
  currentAggregationOrder: number | null,
): number => (currentAggregationOrder ?? currentlyDisplayedPageIndex) + 1;
